import React from 'react'
import styles from './MicrositeRedirectTypeBadge.module.css'

/**
 * MicrositeRedirectTypeBadge
 * 301 (permanent, green) vs 302 (temporary, amber) pill.
 *
 * Usage:
 *   <MicrositeRedirectTypeBadge value={row.redirectType} />
 */
const MicrositeRedirectTypeBadge = ({ value }) => {
    const is301 = Number(value) === 301
    return (
        <span className={`${styles.badge} ${is301 ? styles.tone_301 : styles.tone_302}`}>
            {value} {is301 ? 'Permanent' : 'Temporary'}
        </span>
    )
}

export default MicrositeRedirectTypeBadge